import React from 'react';
import CrudManager from '@/components/admin/CrudManager';

const AdminCoupons = () => (
  <CrudManager
    title="Coupons"
    subtitle="Discount codes for orders."
    endpoint="/admin/coupons"
    idField="code"
    useKeyInPath
    columns={[
      { key: 'code', label: 'Code' },
      { key: 'discount_type', label: 'Type' },
      { key: 'discount_value', label: 'Value' },
      { key: 'min_order', label: 'Min order' },
      { key: 'used_count', label: 'Used' },
      { key: 'active', label: 'Active', render: (c) => c.active ? '✓' : '—' },
    ]}
    initial={{ code: '', discount_type: 'percent', discount_value: 10, min_order: 0, valid_from: '', valid_to: '', usage_limit: 1000, active: true }}
    fields={[
      { key: 'code', label: 'Code', required: true, placeholder: 'WELCOME10' },
      { key: 'discount_type', label: 'Discount type', type: 'select', options: [{ value: 'percent', label: 'Percent' }, { value: 'fixed', label: 'Fixed ₹' }] },
      { key: 'discount_value', label: 'Discount value', type: 'number' },
      { key: 'min_order', label: 'Min order (₹)', type: 'number' },
      { key: 'usage_limit', label: 'Usage limit', type: 'number' },
      { key: 'valid_from', label: 'Valid from (ISO date, optional)' },
      { key: 'valid_to', label: 'Valid to (ISO date, optional)' },
      { key: 'active', label: 'Active', type: 'checkbox' },
    ]}
  />
);
export default AdminCoupons;
